<template>
    <img :src="url" :style="{opacity: transparent/100}" alt="" v-bind="$attrs" v-on="$listeners"/>
</template>

<script>
    import func from "../utils/func";

    export default {
        name: "ResourceImg",
        props: {
            id: {
                type: String,
                required: true
            },
            size: Number,
            crop: String,
            resize: String,
            rotate: Number,
            transparent: {
                type: Number,
                default: 100,
            },
        },
        computed: {
            url() {
                let size = Math.ceil(this.size ? this.size : 0);
                let resize = this.resize ? this.resize : (this.size ? `m_8,w_${size},h_${size}` : "");
                return func.imageUrl(this.id, {crop: this.crop, resize: resize, rotate: this.rotate});
            },
        }
    }
</script>
